module.exports = __webpack_public_path__ + "static/media/iconTextbook.3a59d8e0.svg";